import { createFrontendModule } from "@backstage/frontend-plugin-api";
import {
    createFormField,
    FormFieldBlueprint,
} from "@backstage/plugin-scaffolder-react/alpha";

import { OktaToken } from "./component";

const OktaTokenExtension = FormFieldBlueprint.make({
    name: "okta-token-field",
    params: {
        field: async () =>
            createFormField({
                name: "OktaTokenField",
                component: OktaToken,
            }),
    },
});

const scaffolderModuleOktaToken = createFrontendModule({
    pluginId: "scaffolder",
    extensions: [OktaTokenExtension],
});

export default scaffolderModuleOktaToken;
